import { Box, styled } from '@mui/material';
import { CellStyleT } from 'ui/AgGridReact/colDefConfig';

export const StyCadrageAgContainer = styled(Box, { name: 'StyAgContainer' })(
    ({ theme }) => ({
        flex: 1,
        border: '0.5px solid lightgray',
        '.ag-header-cell': {
            textAlign: 'center',
            borderRight: '1px solid lightgray',
        },
        '.ag-header-cell-label': {
            justifyContent: 'center',
        },
        '.ag-header-cell-text': {
            textTransform: 'unset !important',
            color: `${theme.palette.primary.main} !important`,
        },
        '& .ag-root-wrapper-body.ag-layout-normal': {
            height: 'max-content',
        },
    }),
);

export const StyCadrageFilters = styled(Box)(({ theme }) => ({
    maxWidth: '100%',
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(4),
    marginBottom: theme.spacing(6),
}));

export const cellStyleCadrage: CellStyleT = {
    display: 'flex',
    alignItems: 'left',
    borderRight: '0.5px solid lightgray',
};

export const cellStyleCadrageCentered: CellStyleT = {
    ...cellStyleCadrage,
    alignItems: 'center',
    justifyContent: 'center',
};

export const StyEditCustomCadrageGrid = styled(Box, {
    name: 'StyEditCustomCadrageGrid',
})(({ theme }) => ({
    flex: 1,
    '.ag-header-cell': {
        background: theme.palette.lightGrey,
        fontWeight: 'bold',
    },
    '& .ag-root-wrapper-body.ag-layout-normal': {
        height: '70vh',
    },
    '.MuiOutlinedInput-root': {
        background: 'white',
    },
    '.ag-cell-inline-editing': {
        height: 'inherit !important',
    },
}));
